import React from 'react';

const timelineItems = [
  { id: 'select_reward', number: '1', title: 'Reward', description: 'Select your reward' },
  { id: 'achievement_timeline', number: '2', title: 'Timeline', description: 'Choose duration' },
  { id: 'points_timeline', number: '3', title: 'Points', description: 'Review points' },
  { id: 'activities_timeline', number: '4', title: 'Activities', description: 'Choose activities' },
  { id: 'review_timeline', number: '5', title: 'Review', description: 'Confirm goals' },
  { id: 'track_timeline', number: '6', title: 'Track', description: 'Monitor progress' },
];

const TimelineList = ({ activeSection, onSectionClick }) => {
  const sectionOrder = [
    'select_reward',
    'achievement_timeline',
    'points_timeline',
    'activities_timeline',
    'review_timeline',
    'track_timeline',
  ];

  const activeIndex = sectionOrder.indexOf(activeSection);

  return (
    <div className="timeline">
      <div className="timeline-list">
        {timelineItems.map((item, index) => {
          const status =
            index < activeIndex ? 'done' :
            index === activeIndex ? 'active' : '';
          const isClickable = index <= activeIndex;

          return (
            <div
              key={item.id}
              className={`timeline-list-box ${status} p-2 rounded cursor-
             ${
                isClickable ? 'pointer' : 'not-allowed'
              }
             
               ${activeSection === item.id ? 'bg-blue-100' : 'bg-gray-100'}`}
              onClick={() => isClickable && onSectionClick(item.id)}
              
              
            >
              <div className="timeline-list-box-left">
                <span data-title={item.number}></span>
              </div>
              <div className="timeline-list-box-right">
                <h5>{item.title}</h5>
                <p>{item.description}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TimelineList;